import { myFetch } from '@/commons/fetch';

/** One folder row — enough to match saved filters by category for notifications. */
export async function fetchFolderCategoryForNotification(
  folderName: string
): Promise<string> {
  const res = (await myFetch(`/folders/${encodeURIComponent(folderName)}`)) as {
    data?: { category?: string };
  };
  const cat = res?.data?.category;
  return typeof cat === 'string' && cat.length > 0 ? cat : 'UNKNOWN';
}
